import Vue from 'vue'
import Product from './product.vue'
import '@/common/config.js'
import utils from '@/common/js/utils.js'
// 引入公共CSS文件
import '@/common/app.css';
import 'swiper/css/swiper.min.css';
import {Icon} from "element-ui";

Vue.use(Icon);

Vue.prototype.$util = utils;

new Vue({
    render: h => h(Product),
}).$mount('#app')